const STEPS = [
  {
    title: 'Read real text',
    body: 'Stories, articles and letters written for people, not textbooks. You begin where you are and grow into the language sentence by sentence.',
  },
  {
    title: 'Understand instantly',
    body: "Tap any word for its meaning in context — the sense it carries here, not a dictionary's longest guess. Nothing breaks your reading.",
  },
  {
    title: 'Remember naturally',
    body: 'Words you meet return at just the right moment, woven back into new reading. Memory is built quietly, in the background.',
  },
]

export function MethodSection() {
  return (
    <section className="relative z-10 border-t border-line-soft py-12 sm:py-20">
      <div className="max-w-5xl mx-auto px-4 sm:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-16">
          {STEPS.map((step) => (
            <div key={step.title} className="flex flex-col gap-3">
              <span
                className="block w-6 mb-1"
                style={{ height: '1px', background: 'var(--color-accent)', opacity: 0.65 }}
              />
              <h3 className="font-serif text-xl font-medium leading-tight text-heading">
                {step.title}
              </h3>
              <p className="font-serif text-base leading-relaxed text-muted">{step.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
